'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _firebase = require('firebase');

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataFlow = function () {
    function DataFlow(options) {
        (0, _classCallCheck3.default)(this, DataFlow);

        var firebaseApp = _firebase2.default.initializeApp(options);

        this.firestore = firebaseApp.firestore();

        this.urls = this.firestore.collection('urls');
    }

    (0, _createClass3.default)(DataFlow, [{
        key: 'getAllUrls',
        value: function getAllUrls() {
            var urls = {};
            return this.firestore.collection('urls').get().then(function (data) {
                data.forEach(function (doc) {
                    urls[doc.id] = doc.data();
                });
                return urls;
            }).catch(function (error) {
                return {};
            });
        }
    }, {
        key: 'findUrls',
        value: function findUrls(url) {
            var result = {};
            return this.urls.where('url', '==', url).get().then(function (data) {
                data.forEach(function (doc) {
                    result[doc.id] = doc.data();
                });
                return result;
            }).catch(function (error) {
                return {};
            });
        }
    }, {
        key: 'findOneUrl',
        value: function findOneUrl(url) {
            var result = null;
            return this.urls.where('url', '==', url).limit(1).get().then(function (data) {
                data.forEach(function (doc) {
                    result = doc.data();
                });
                return result;
            }).catch(function (error) {
                return {};
            });
        }
    }, {
        key: 'subscribeUrls',
        value: function subscribeUrls(url, callback) {
            return this.urls.where('url', '==', url).onSnapshot(function (data) {
                var result = [];
                data.forEach(function (doc) {
                    result.push(doc.data());
                });

                if (result.length > 0) {
                    callback(result[0]);
                }
            });
        }
    }, {
        key: 'getData',
        value: function getData() {
            return {
                urls: this.urls
            };
        }
    }]);
    return DataFlow;
}();

exports.default = DataFlow;


//////////////////
// WEBPACK FOOTER
// ./src/helpers/DataFlow.js
// module id = dcj1
// module chunks = 1